const JOURNAL_KEY = "wp-owner-jarvis-conversation-journal-v1";
const CONVERSATION_ID_KEY = "wp-owner-jarvis-conversation-id-v1";
const MAX_MESSAGES = 120;
const MAX_TEXT = 2400;

function clean(value, max = MAX_TEXT) {
  return String(value ?? "").trim().slice(0, max);
}

function safeNowIso() {
  try { return new Date().toISOString(); } catch { return ""; }
}

function randomConversationId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `jarvis-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function ownerJarvisConversationId() {
  if (typeof window === "undefined") return "server";
  try {
    const existing = clean(window.sessionStorage.getItem(CONVERSATION_ID_KEY), 120);
    if (existing) return existing;
    const next = randomConversationId();
    window.sessionStorage.setItem(CONVERSATION_ID_KEY, next);
    return next;
  } catch {
    return randomConversationId();
  }
}

function readJournal() {
  if (typeof window === "undefined") return [];
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(JOURNAL_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function appendOwnerJarvisConversationMessage(role, text, meta = {}) {
  if (typeof window === "undefined") return;
  const safeRole = role === "assistant" ? "assistant" : "user";
  const safeText = clean(text);
  if (!safeText) return;
  try {
    const rows = readJournal();
    const last = rows[rows.length - 1];
    // El runtime de voz y OwnerJarvis2 pueden observar el mismo turno. Evitamos
    // duplicarlo sin perder mensajes genuinamente repetidos más tarde.
    if (last && last.role === safeRole && last.text === safeText && Date.now() - Number(last.ts || 0) < 2500) return;
    rows.push({
      role: safeRole,
      text: safeText,
      at: safeNowIso(),
      ts: Date.now(),
      inputSource: clean(meta.inputSource, 20),
      path: clean(meta.path || (window.location ? `${window.location.pathname || ""}${window.location.search || ""}` : ""), 500),
    });
    window.sessionStorage.setItem(JOURNAL_KEY, JSON.stringify(rows.slice(-MAX_MESSAGES)));
  } catch { /* sessionStorage opcional */ }
}

export function ownerJarvisConversationContext({ limit = 96 } = {}) {
  const rows = readJournal().slice(-Math.max(1, Math.min(MAX_MESSAGES, Number(limit || 48))));
  return {
    conversationId: ownerJarvisConversationId(),
    messages: rows.map(({ role, text, at, inputSource, path }) => ({ role, text, at, inputSource, path })),
  };
}

export function clearOwnerJarvisConversationJournal() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(JOURNAL_KEY);
    window.sessionStorage.removeItem(CONVERSATION_ID_KEY);
  } catch { /* sessionStorage opcional */ }
}
